import { useMemo } from 'react';
import { ContactsHooks } from '@frontend/contacts';
import { useTranslation } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { createNavItem, createSubNavItems } from '../nav-item-utils';
import { featureDefinition as contactsFeatureDefinition } from './feature-definitions';

export const useContactsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const tokens = useTranslationTokens();
  const hasListHomeIconAccess = ContactsHooks.useHasListHomeIconAccess();
  const contactsItems = contactsFeatureDefinition.items;

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          ...contactsItems['/all-contacts'],
          relativePath: '/all-contacts',
          label: tokens.allContacts,
        },
        {
          ...contactsItems['/lists'],
          relativePath: '/lists',
          label: t('Lists'),
          show: hasListHomeIconAccess,
        },
      ]),
    [t, tokens.allContacts, hasListHomeIconAccess, contactsItems]
  );

  return useMemo(
    () =>
      createNavItem('contacts', {
        iconName: 'contacts',
        label: tokens.contacts,
        root: '/contacts',
        subNavItems,
      }),
    [tokens.contacts, subNavItems]
  );
};
